/* NukkadTales — global quick-view
 *
 * Color architecture — single source of truth:
 *   snippets/nt-card.liquid resolves every color name → hex (Shopify native
 *   swatches first, name-based fallbacks second) and writes the result into
 *   data-color="..." on every swatch span (visible + hidden).
 *   ntOpenQV reads those data-color values into _qvSwatchMap so the QV always
 *   mirrors the card exactly.  To add or rename a color, only edit nt-card.liquid.
 */
(function () {
  'use strict';

  // Returns true when a color string is light enough to need a border in QV
  function isLightColor(bg) {
    if (!bg) return false;
    // Parse hex
    var m = bg.match(/^#([0-9a-f]{3,6})$/i);
    if (m) {
      var hex = m[1].length === 3
        ? m[1].split('').map(function (c) { return c + c; }).join('')
        : m[1];
      var r = parseInt(hex.slice(0, 2), 16);
      var g = parseInt(hex.slice(2, 4), 16);
      var b = parseInt(hex.slice(4, 6), 16);
      return (r * 0.299 + g * 0.587 + b * 0.114) > 180;
    }
    // Parse rgb(R, G, B)
    m = bg.match(/rgb\(\s*(\d+),\s*(\d+),\s*(\d+)/i);
    if (m) return (parseInt(m[1]) * 0.299 + parseInt(m[2]) * 0.587 + parseInt(m[3]) * 0.114) > 180;
    return false;
  }

  // Populated from card DOM on QV open — nt-card.liquid is the source of truth
  var _qvSwatchMap = {};

  function colorHex(name) {
    // Card DOM is primary; NT_COLOR_MAP is last-resort for edge cases
    return _qvSwatchMap[name] || (window.NT_COLOR_MAP && window.NT_COLOR_MAP[name]) || 'var(--accent)';
  }

  function isColorOpt(name) {
    if (!name || typeof name !== 'string') return false;
    var n = name.toLowerCase();
    return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 ||
           n.indexOf('finish') !== -1 || n.indexOf('shade') !== -1 ||
           n.indexOf('wood') !== -1 || n.indexOf('material') !== -1 ||
           n.indexOf('texture') !== -1;
  }

  var _qvOpen = false;
  var _qvSel = {};
  var _qvProd = null;

  window.ntOpenQV = function (handle, url, btn) {
    // Read swatch colors from the rendered card so QV matches exactly
    _qvSwatchMap = {};
    if (btn) {
      var card = btn.closest('a.pcard') || btn.parentNode;
      if (card) {
        // Read both visible swatches and hidden data-only spans (beyond limit:5)
        card.querySelectorAll('.pswatch[title], .pswatch-data[title]').forEach(function (s) {
          var bg = s.getAttribute('data-color') || '';
          if (bg) _qvSwatchMap[s.getAttribute('title')] = bg;
        });
      }
    }
    var qv = document.getElementById('ntQV');
    var body = document.getElementById('ntQVBody');
    if (!qv || !body) return;
    body.innerHTML = '<div class="nt-gulloader"><span class="nt-gulload lg" style="--nt-gul-spr:url(' + (window.NT_GUL_SPR13 || '') + ')"></span><span>Gul\'s fetching this tale…</span></div>';
    qv.classList.add('open');
    _qvOpen = true;
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (p) { _renderQV(p, url); })
      .catch(function (err) {
        console.error('[ntQV] fetch failed for', handle, err);
        var b2 = document.getElementById('ntQVBody');
        if (b2) b2.innerHTML = '<div class="nt-qv-loading">Could not load product.</div>';
      });
  };

  function _stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function _renderQV(p, url) {
    var body = document.getElementById('ntQVBody');
    if (!body) return;
    _qvProd = p;

    var variants = p.variants || [];
    var rawOptions = p.options || [];
    var options = rawOptions.map(function (o) {
      return typeof o === 'string' ? o : (o && typeof o.name === 'string' ? o.name : '');
    });
    var isSingle = options.length === 1 && options[0] === 'Title';

    var firstAvail = variants.find(function (v) { return v.available; }) || variants[0];
    _qvSel = {};
    if (firstAvail) {
      options.forEach(function (_, i) { _qvSel[i] = firstAvail['option' + (i + 1)]; });
    }

    var optVals = options.map(function () { return []; });
    variants.forEach(function (v) {
      options.forEach(function (_, i) {
        var val = v['option' + (i + 1)];
        if (optVals[i].indexOf(val) === -1) optVals[i].push(val);
      });
    });

    var curVariant = _findVariant(variants, options, _qvSel) || firstAvail;
    var price = curVariant ? curVariant.price : p.price;
    var compareAt = curVariant ? (curVariant.compare_at_price || 0) : (p.compare_at_price_min || 0);
    var hasDiscount = compareAt && compareAt > price;
    var discountPct = hasDiscount ? Math.round((1 - price / compareAt) * 100) : 0;

    // Images
    var images = (p.images || []).map(function (im) { return im.src || im; }).filter(Boolean);
    var mainImg = images[0] || '';

    // Description — strip HTML, truncate
    var desc = p.description ? _stripHtml(p.description) : '';
    if (desc.length > 180) desc = desc.slice(0, 177) + '…';

    // Option pickers
    var optHtml = '';
    if (!isSingle) {
      options.forEach(function (optName, oi) {
        if (!optName) return;
        // Single-value option = nothing to choose, but the customer should
        // still SEE it → show the value as read-only text, no swatch button.
        if (!optVals[oi] || optVals[oi].length < 2) {
          if (optVals[oi] && optVals[oi].length === 1) {
            optHtml += '<div class="nt-qv-opt nt-qv-opt-single">'
              + '<div class="nt-qv-opt-label">' + _esc(optName)
              + ' <span class="nt-qv-opt-cur">— ' + _esc(optVals[oi][0]) + '</span></div></div>';
          }
          return;
        }
        var isColor = isColorOpt(optName);
        optHtml += '<div class="nt-qv-opt">'
          + '<div class="nt-qv-opt-label">' + _esc(optName)
          + (_qvSel[oi] ? ' <span class="nt-qv-opt-cur">— ' + _esc(_qvSel[oi]) + '</span>' : '')
          + '</div>'
          + '<div class="nt-qv-opt-vals">';
        optVals[oi].forEach(function (val) {
          var avail = _isAvail(variants, options, _qvSel, oi, val);
          var isOn = _qvSel[oi] === val;
          if (isColor) {
            var bg = colorHex(val);
            var needBorder = isLightColor(bg);
            optHtml += '<button class="nt-qv-swatch' + (isOn ? ' on' : '') + (avail ? '' : ' oos') + '"'
              + ' data-opt="' + oi + '" data-val="' + _esc(val) + '"'
              + ' style="background:' + bg + (needBorder ? ';outline-color:#aaa' : '') + '"'
              + ' title="' + _esc(val) + '" aria-label="' + _esc(val) + '"'
              + ' onclick="ntQVOptSel(this)"></button>';
          } else {
            optHtml += '<button class="nt-qv-vbtn' + (isOn ? ' on' : '') + (avail ? '' : ' oos') + '"'
              + ' data-opt="' + oi + '" data-val="' + _esc(val) + '"'
              + ' onclick="ntQVOptSel(this)">' + _esc(val) + '</button>';
          }
        });
        optHtml += '</div></div>';
      });
    }

    // Gallery thumbnails
    var thumbsHtml = '';
    if (images.length > 1) {
      thumbsHtml = '<div class="nt-qv-thumbs">';
      images.slice(0, 5).forEach(function (src, idx) {
        thumbsHtml += '<button class="nt-qv-thumb' + (idx === 0 ? ' on' : '') + '"'
          + ' onclick="ntQVSetImg(this,\'' + src.replace(/'/g, "\\'") + '\')"'
          + ' style="background-image:url(' + src + ')"'
          + ' aria-label="Image ' + (idx + 1) + '"></button>';
      });
      thumbsHtml += '</div>';
    }

    var vendor = p.vendor ? ('<span class="nt-qv-vendor">' + _esc(p.vendor) + '</span>') : '';
    var eyebrow = p.type || p.vendor ? _esc(p.type || p.vendor) : '';

    body.innerHTML =
      '<div class="nt-qv-inner">' +
        '<div class="nt-qv-gallery">' +
          (mainImg
            ? '<img class="nt-qv-img" id="ntQVMainImg" src="' + mainImg + '" alt="' + _esc(p.title) + '">'
            : '<div class="nt-qv-img nt-qv-img-ph"></div>') +
          thumbsHtml +
        '</div>' +
        '<div class="nt-qv-content">' +
          (eyebrow ? '<div class="nt-qv-eyebrow">' + eyebrow + '</div>' : '') +
          '<div class="nt-qv-title">' + p.title + '</div>' +
          '<div class="nt-qv-pricing" id="ntQVPricing">' + _pricingHtml(price, compareAt, hasDiscount, discountPct) + '</div>' +
          (hasDiscount && p.available !== false ? (function(){ var fv = p.variants && p.variants[0]; var rq = fv ? (fv.inventory_quantity || 0) : 0; var n = (rq > 0 && rq < 5) ? rq : ((p.id % 7) + 2); return '<div style="display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:800;padding:8px 14px;border-radius:100px;margin:4px 0 10px;background:#fde8e8;color:#c62828;border:1.5px solid rgba(198,40,40,.35);">⚡ Only ' + n + ' left — not restocking</div>'; })() : '') +
          optHtml +
          '<div class="nt-qv-actions">' +
            '<div class="nt-qv-qty">' +
              '<button class="nt-qv-qty-btn" onclick="ntQVQtyAdj(-1)">&#8722;</button>' +
              '<span id="ntQVQty">1</span>' +
              '<button class="nt-qv-qty-btn" onclick="ntQVQtyAdj(1)">+</button>' +
            '</div>' +
            '<button class="nt-qv-atc" id="ntQVAtc"' + (curVariant && !curVariant.available ? ' disabled' : '') + '>' +
              (curVariant && !curVariant.available ? 'Sold out' : 'Add to cart') +
            '</button>' +
          '</div>' +
          '<div class="nt-qv-trust">' +
            '<div class="nt-qv-trustitem"><span class="nt-qv-ti">&#10042;</span><b>Engineered wood</b><small>handcrafted by artisan families</small></div>' +
            '<div class="nt-qv-trustitem"><span class="nt-qv-ti">&#8617;</span><b>7-day returns</b><small>easy, no-fuss policy</small></div>' +
            '<div class="nt-qv-trustitem"><span class="nt-qv-ti">🚚</span><b>Delivery 7&ndash;10 days</b><small>painted on order, takes a little</small></div>' +
          '</div>' +
          '<a href="/policies/refund-policy" class="nt-qv-policy">No two are alike &mdash; handcrafted &amp; painted to order. See full policy &rarr;</a>' +
        '</div>' +
      '</div>';

    var atc = document.getElementById('ntQVAtc');
    if (atc && curVariant) {
      atc.onclick = function () { ntAddToCart(curVariant.id, p.title); };
    }
  }

  function _pricingHtml(price, compareAt, hasDiscount, discountPct) {
    var h = '<span class="nt-qv-price-now" id="ntQVPriceNow">' + _fmt(price / 100) + '</span>';
    if (hasDiscount) {
      h += ' <span class="nt-qv-price-was" id="ntQVPriceWas">' + _fmt(compareAt / 100) + '</span>'
        + ' <span class="nt-qv-save">-' + discountPct + '%</span>';
    }
    return h;
  }

  window.ntQVSetImg = function (btn, src) {
    var img = document.getElementById('ntQVMainImg');
    if (img) img.src = src;
    btn.parentNode.querySelectorAll('.nt-qv-thumb').forEach(function (t) { t.classList.remove('on'); });
    btn.classList.add('on');
  };

  window.ntQVOptSel = function (btn) {
    if (!_qvProd) return;
    var oi = parseInt(btn.dataset.opt, 10);
    var val = btn.dataset.val;
    _qvSel[oi] = val;

    var p = _qvProd;
    var variants = p.variants || [];
    var options = (p.options || []).map(function (o) {
      return typeof o === 'string' ? o : (o && typeof o.name === 'string' ? o.name : '');
    });

    btn.parentNode.querySelectorAll('[data-opt]').forEach(function (b) {
      b.classList.toggle('on', b.dataset.val === val);
    });

    // Update selected label
    var label = btn.closest('.nt-qv-opt') && btn.closest('.nt-qv-opt').querySelector('.nt-qv-opt-cur');
    if (label) label.textContent = '— ' + val;

    options.forEach(function (_, oi2) {
      if (oi2 === oi) return;
      var container = document.querySelector('.nt-qv-opt-vals [data-opt="' + oi2 + '"]');
      if (!container) return;
      container.parentNode.querySelectorAll('[data-opt="' + oi2 + '"]').forEach(function (b) {
        b.classList.toggle('oos', !_isAvail(variants, options, _qvSel, oi2, b.dataset.val));
      });
    });

    var variant = _findVariant(variants, options, _qvSel);
    var pricingEl = document.getElementById('ntQVPricing');
    if (pricingEl && variant) {
      var ca = variant.compare_at_price || 0;
      var hasD = ca && ca > variant.price;
      var pct = hasD ? Math.round((1 - variant.price / ca) * 100) : 0;
      pricingEl.innerHTML = _pricingHtml(variant.price, ca, hasD, pct);
    }
    var atc = document.getElementById('ntQVAtc');
    if (atc && variant) {
      atc.onclick = function () { ntAddToCart(variant.id, p.title); };
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
  };

  window.ntQVQtyAdj = function (delta) {
    var el = document.getElementById('ntQVQty');
    if (!el) return;
    el.textContent = Math.max(1, (parseInt(el.textContent, 10) || 1) + delta);
  };

  window.ntCloseQV = function () {
    var qv = document.getElementById('ntQV');
    if (qv) qv.classList.remove('open');
    _qvOpen = false;
  };

  var _atcInProgress = false;
  window.ntAddToCart = function (variantId, title) {
    if (!variantId || _atcInProgress) return;
    _atcInProgress = true;
    var qty = parseInt((document.getElementById('ntQVQty') || {}).textContent, 10) || 1;
    var atc = document.getElementById('ntQVAtc');
    if (atc) { atc.textContent = 'Adding…'; atc.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        _atcInProgress = false;
        ntCloseQV();
        if (typeof window.handleFloCartBtn === 'function') {
          window.handleFloCartBtn();
        }
      })
      .catch(function () {
        _atcInProgress = false;
        if (atc) { atc.textContent = 'Add to cart'; atc.disabled = false; }
      });
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (_qvOpen) ntCloseQV();
      else setTimeout(clearScrollLock, 150); // close Shopflo cart then restore scroll
    }
  });

  // ---- Scroll-lock recovery ----
  // Shopflo adds 'overflow-hidden' when its cart opens but may not remove it on close.
  function clearScrollLock() {
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function _tryUnlockScroll() {
    if (!document.body.classList.contains('overflow-hidden')) return;
    if (_qvOpen) return;
    var nativeDrawer = document.querySelector('cart-drawer.active');
    var openModal = document.querySelector('modal-dialog[open], details-modal[open]');
    if (!nativeDrawer && !openModal) clearScrollLock();
  }

  // Method 1: standard cart-close events
  ['cart:close', 'cart:closed', 'flo:cart:close', 'flo:close',
   'drawer:close', 'cart:after-close'].forEach(function (ev) {
    document.addEventListener(ev, clearScrollLock);
  });

  // Method 2: click fallback — 400ms delay lets cart close animation finish first
  document.addEventListener('click', function () { setTimeout(_tryUnlockScroll, 400); });

  // Method 3: touchend fallback — mobile swipe-to-close doesn't fire click
  document.addEventListener('touchend', function () { setTimeout(_tryUnlockScroll, 400); });

  // Method 4: wheel fallback — user tries to scroll with mouse wheel while stuck
  document.addEventListener('wheel', _tryUnlockScroll, { passive: true });

  // Method 5: MutationObserver — catches auto-dismiss where no interaction fires at all
  // When overflow-hidden is added while QV is not open, schedule a safety cleanup.
  if (window.MutationObserver) {
    var _slTimer = null;
    new MutationObserver(function () {
      var locked = document.body.classList.contains('overflow-hidden');
      if (!locked || _qvOpen) { clearTimeout(_slTimer); _slTimer = null; return; }
      if (_slTimer) return; // already scheduled
      _slTimer = setTimeout(function () { _slTimer = null; _tryUnlockScroll(); }, 3000);
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function _isAvail(variants, options, sel, targetOpt, targetVal) {
    return variants.some(function (v) {
      if (!v.available) return false;
      return options.every(function (_, i) {
        if (i === targetOpt) return v['option' + (i + 1)] === targetVal;
        return sel[i] == null || v['option' + (i + 1)] === sel[i];
      });
    });
  }

  function _findVariant(variants, options, sel) {
    return variants.find(function (v) {
      return options.every(function (_, i) { return v['option' + (i + 1)] === sel[i]; });
    });
  }

  function _fmt(price) {
    return '₹' + (price % 1 === 0 ? price : price.toFixed(2));
  }

  function _esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Foxify-safe: onclick stripped from card buttons — use event delegation.
  // touchend fires on touch-screen desktops before the synthetic click, so we open
  // QV there. The click handler always prevents <a> navigation, then skips ntOpenQV
  // if touchend already handled it — this way mobile scroll is never blocked.
  var _touchHandled = false;
  var _ntTouchStartY = 0;
  var _ntTouchMoved = false;
  document.addEventListener('touchstart', function (e) {
    _ntTouchStartY = e.touches[0].clientY;
    _ntTouchMoved = false;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (Math.abs(e.touches[0].clientY - _ntTouchStartY) > 8) _ntTouchMoved = true;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    var btn = e.target.closest('[data-qv-handle]');
    if (!btn) return;
    if (_ntTouchMoved) return; // user was scrolling — don't open QV
    e.preventDefault();
    _touchHandled = true;
    setTimeout(function () { _touchHandled = false; }, 600);
    ntOpenQV(btn.getAttribute('data-qv-handle'), btn.getAttribute('data-qv-url'), btn);
  }, { passive: false });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qv-handle]');
    if (!btn) return;
    e.preventDefault(); // always block <a> navigation for QV buttons
    e.stopPropagation();
    if (_touchHandled) return; // touchend already opened QV — don't double-fire
    ntOpenQV(btn.getAttribute('data-qv-handle'), btn.getAttribute('data-qv-url'), btn);
  });

  // Drain any clicks queued before this script loaded
  (window._ntQ || []).forEach(function (a) { ntOpenQV(a[0], a[1]); });
  window._ntQ = null;
})();

/* Product page making-of video player — defined here (external asset) because
   Foxify blocks inline section scripts that would otherwise define it. */
window.ntpsPlayVideo = function (url, wrap) {
  if (!url) return;
  var embed = url;
  if (url.indexOf('watch?v=') >= 0) embed = 'https://www.youtube.com/embed/' + url.split('watch?v=')[1].split('&')[0];
  else if (url.indexOf('youtu.be/') >= 0) embed = 'https://www.youtube.com/embed/' + url.split('youtu.be/')[1].split('?')[0];
  else if (url.indexOf('youtube.com/shorts/') >= 0) embed = 'https://www.youtube.com/embed/' + url.split('shorts/')[1].split('?')[0];
  var vm = url.match(/vimeo\.com\/(\d+)/); if (vm) embed = 'https://player.vimeo.com/video/' + vm[1];
  if (/\.mp4($|\?)/i.test(url)) {
    if (wrap) wrap.innerHTML = '<video src="' + url + '" autoplay controls playsinline style="width:100%;height:100%;object-fit:cover;display:block;"></video>';
    return;
  }
  var ov = document.getElementById('ntlVideoOverlay');
  if (!ov) {
    ov = document.createElement('div');
    ov.id = 'ntlVideoOverlay';
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:99999;display:flex;align-items:center;justify-content:center;';
    ov.innerHTML = '<div style="position:relative;width:min(100vw,calc(100vh*9/16));height:min(100vh,calc(100vw*16/9));max-width:100vw;max-height:100vh;">'
      + '<iframe id="ntlVideoFrame" src="" frameborder="0" allowfullscreen allow="autoplay" style="position:absolute;inset:0;width:100%;height:100%;display:block;border:none;"></iframe>'
      + '<button onclick="window.ntlCloseVideo()" style="position:absolute;top:-44px;right:0;background:rgba(255,255,255,0.15);border:none;border-radius:50%;width:36px;height:36px;color:#fff;font-size:20px;cursor:pointer;line-height:1;">&#x2715;</button>'
      + '</div>';
    ov.addEventListener('click', function (e) { if (e.target === ov) window.ntlCloseVideo(); });
    document.body.appendChild(ov);
  }
  window.ntlCloseVideo = function () {
    var o = document.getElementById('ntlVideoOverlay');
    if (o) { o.style.display = 'none'; var f = document.getElementById('ntlVideoFrame'); if (f) f.src = ''; }
    document.body.style.overflow = '';
  };
  document.getElementById('ntlVideoFrame').src = embed + '?autoplay=1&mute=1';
  ov.style.display = 'flex';
  document.body.style.overflow = 'hidden';
};
